<template>
    <div class="features">
        <div class="features-sidenav">
            <div v-for="(item, index) in navItems" :class="[{ 'nav-active': isActive[index] }, 'nav-item']" :style="style" @click="toggleActive(index)" :key="item.name">
                <fa-icon v-if="item.icon"
                         :icon="['fas', item.icon]"
                         aria-hidden="true">
                </fa-icon>
                <h2>{{item.name}}</h2>
                <p v-if="isActive[index]">{{item.description}}</p>
            </div>
        </div>
        <div class="features-nav-mobile">
            <div v-for="(item, index) in navItems" :class="[{ 'nav-active': isActive[index] }, 'nav-item-mob']" @click="toggleActive(index)" :key="item.name">
                <span>{{item.name}}</span>
            </div>
        </div>
        <div :class="['features-table', {'background-grey': (tableHeading == 'Promotions' || tableHeading.toLowerCase().includes('protection'))}]">
            <div class="table-header" v-if="!tableHeading.toLowerCase().includes('protection')">
                <div class="heading">
                    <h3>{{tableHeading}}</h3>
                </div>
                <div>
                    <div v-if="tableHeading == 'Promotions'"></div>
                    <div v-if="features[0].guest" class="account-type guest"><p>Guest<br /><span>No Account</span></p></div>
                    <div v-if="features[0].guest" class="under guest"></div>
                    <div v-if="features[0]['no-account']" class="account-type no-account"><p>Stock Listing<br /></p></div>
                    <div v-if="features[0]['no-account']" class="under no-account"></div>
                </div>
                <div>
                    <div v-if="features[0].free" class="account-type free"><p>Individual<br /><span>Free</span></p></div>
                    <div v-if="features[0].free" class="under free"></div>
                    <div v-if="features[0].pro || tableHeading == 'Promotions'" class="account-type pro"><img :src="proImg" alt="Pro Truckdown Membership Logo" width="65" height="65"/></div>
                    <div v-if="features[0].pro || tableHeading == 'Promotions'" class="under pro"></div>
                </div>
                <div>
                    <div v-if="features[0].fleet" class="account-type fleet"><p>Fleet<br /><span>Subscription</span></p></div>
                    <div v-if="features[0].fleet" class="under fleet"></div>
                    <div v-if="features[0].elite || tableHeading == 'Promotions'" class="account-type elite"><img :src="eliteImg" alt="Pro Truckdown Membership Logo" width="65" height="65"/></div>
                    <div v-if="features[0].elite || tableHeading == 'Promotions'" class="under elite"></div>
                </div>
            </div>
            <div class="table-row justify-center" v-if="!isPathIncludesShopFleets || tableHeading.toLowerCase().includes('protection')">
                <div></div>
                <div v-if="!features[0]['no-account']"></div>
                <div class="account-no-account" v-if="features[0]['no-account']">
                    <button v-if="shouldShowCallToAction('stock')" @click="callToAction('stock')" class="account account-stock" :title="callToActionTitle('stock')">{{ callToActionLabel('stock') }}</button>
                </div>

                <div v-if="features[0].free">
                    <button v-if="shouldShowCallToAction('free')" @click="callToAction('free')" class="account account-free" :title="callToActionTitle('free')">{{ callToActionLabel('free') }}</button>
                </div>
                <div v-if="features[0].pro">
                    <button v-if="shouldShowCallToAction('pro')" @click="callToAction('pro')" class="account account-pro" :title="callToActionTitle('pro')">{{ callToActionLabel('pro') }}</button>
                </div>
                <div v-if="features[0].fleet">
                    <button v-if="shouldShowCallToAction('fleet')" @click="callToAction('fleet')" class="account account-fleet" :title="callToActionTitle('fleet')">{{ callToActionLabel('fleet') }}</button>
                </div>
                <div v-if="features[0].elite">
                    <button v-if="shouldShowCallToAction('elite')" @click="callToAction('elite')" class="account account-free" :title="callToActionTitle('elite')">{{ callToActionLabel('elite') }}</button>
                </div>
                <div v-if="tableHeading == 'Promotions'" class="long">
                    <button v-if="shouldShowCallToAction('promotion')" @click="callToAction('promotion')" class="account account-free" :title="callToActionTitle('promotion')"> {{ callToActionLabel('promotion') }}</button>
                </div>
            </div>
            <div :class="['table-row', {'single-column': (!feature['no-account'] && !feature['guest']) || tableHeading.toLowerCase().includes('protection')}]" v-for="feature in features" :key="feature.name">
                <div>
                    <h3>{{feature.name}}</h3>
                    <p :class="{'mb-1': feature.name == 'How You Can Help Ensure Quality Listings'}">{{feature.description}}</p>
                    <a class="td-link" href="/shop/verification" title="More about verification process"
                       v-if="feature.name == 'How You Can Help Ensure Quality Listings'">
                        Learn More
                        <fa-icon :icon="['fas', 'angle-right']" aria-hidden="true"></fa-icon>
                        <fa-icon :icon="['fas', 'angle-right']" aria-hidden="true"></fa-icon>
                    </a>
                </div>
                <div class="column-guest" v-if="feature.guest">

                    <fa-icon v-if="feature.guest.icon[1]"
                             :class="[{ 'grey': feature.guest.icon[1] === 'circle-xmark' }]"
                             :icon="[feature.guest.icon[0], feature.guest.icon[1]]"
                             aria-hidden="true">
                    </fa-icon>
                    <span v-if="feature.guest.text"> {{feature.guest.text}}</span>
                </div>
                <div class="column-no-account" v-if="feature['no-account']">
                    <fa-icon v-if="feature['no-account'].icon[1]"
                             :class="[{ 'grey': feature['no-account'].icon[1] === 'circle-xmark' }]"
                             :icon="[feature['no-account'].icon[0], feature['no-account'].icon[1]]"
                             aria-hidden="true">
                    </fa-icon>

                    <span v-if="feature['no-account'].text"> {{feature['no-account'].text}}</span>
                </div>
                <div class="column-free" v-if="feature.free">
                    <fa-icon v-if="feature.free.icon[1]"
                             :class="{ grey: feature.free.icon[1] == 'circle-xmark' }"
                             :icon="[feature.free.icon[0], feature.free.icon[1]]"
                             aria-hidden="true">
                    </fa-icon>

                    <span v-if="feature.free.text"> {{feature.free.text}}</span>
                </div>
                <div class="column-pro" v-if="feature.pro">
                    <fa-icon v-if="feature.pro.icon[1]"
                             :class="{ grey: feature.pro.icon[1] == 'circle-xmark' }"
                             :icon="[feature.pro.icon[0], feature.pro.icon[1]]"
                             aria-hidden="true">
                    </fa-icon>
                    <span v-if="feature.pro.text"> {{feature.pro.text}}</span>
                </div>
                <div class="column-fleet" v-if="feature.fleet">
                    <fa-icon v-if="feature.fleet.icon[1]"
                             :class="{ grey: feature.fleet.icon[1] == 'circle-xmark' }"
                             :icon="[feature.fleet.icon[0], feature.fleet.icon[1]]"
                             aria-hidden="true">
                    </fa-icon>

                    <span v-if="feature.fleet.text"> {{feature.fleet.text}}</span>
                </div>
                <div class="column-elite" v-if="feature.elite">
                    <fa-icon v-if="feature.elite.icon[1]"
                             :class="{ grey: feature.elite.icon[1] == 'circle-xmark' }"
                             :icon="[feature.elite.icon[0], feature.elite.icon[1]]"
                             aria-hidden="true">
                    </fa-icon>
                    <span v-if="feature.elite.text"> {{feature.elite.text}}</span>
                </div>
            </div>
            <div class="table-row footer" v-if="!tableHeading.toLowerCase().includes('protection')">
                <div></div>
                <div v-if="!features[0]['no-account']"></div>
                <div class="account-no-account" v-if="features[0]['no-account']">
                    <button v-if="shouldShowCallToAction('stock')" @click="callToAction('stock')" class="account account-stock" :title="callToActionTitle('stock')">{{ callToActionLabel('stock') }}</button>
                </div>

                <div v-if="features[0].free">
                    <button v-if="shouldShowCallToAction('free')" @click="callToAction('free')" class="account account-free" :title="callToActionTitle('free')">{{ callToActionLabel('free') }}</button>
                </div>
                <div v-if="features[0].pro">
                    <button v-if="shouldShowCallToAction('pro')" @click="callToAction('pro')" class="account account-pro" :title="callToActionTitle('pro')">{{ callToActionLabel('pro') }}</button>
                </div>
                <div v-if="features[0].fleet">
                    <button v-if="shouldShowCallToAction('fleet')" @click="callToAction('fleet')" class="account account-fleet" :title="callToActionTitle('fleet')">{{ callToActionLabel('fleet') }}</button>
                </div>
                <div v-if="features[0].elite">
                    <button v-if="shouldShowCallToAction('elite')" @click="callToAction('elite')" class="account account-free" :title="callToActionTitle('elite')">{{ callToActionLabel('elite') }}</button>
                </div>
                <div v-if="tableHeading == 'Promotions'" class="long">
                    <button v-if="shouldShowCallToAction('promotion')" @click="callToAction('promotion')" class="account account-free" :title="callToActionTitle('promotion')"> {{ callToActionLabel('promotion') }}</button>
                </div>
            </div>
            <div v-else class="footer table-row">
                <button v-if="shouldShowCallToAction('fleet')" class="td-btn primary" @click="callToAction('protection')" :title="callToActionTitle('protection')">{{ callToActionLabel('protection') }}</button>
            </div>

        </div>
    </div>
</template>

<script>import script from './Features';
    export default script;</script>

<style lang="less" scoped>
    @import "./Features.less";
</style>
